/**
 * Created by Yangxunwu on 2018/7/23.
 */

import request from '@/utils/request'

/**
 * 安装应用等待页面
 * @param authCode
 */
export function installQywxGzt(authCode) {

	return request({
		url: '/qywx/auth/install',
		method: 'get',
		params: { auth_code : authCode }
	})
}

/**
 * 检查同步数据状态
 * @param data
 */
export function getSyncJobStatus(data) {

    return request({
        url: '/qywx/auth/sync-job-status',
        method: 'POST',
        data,
    })
}

/**
 * 单点登录等待页面
 * @param authCode
 */
export function ssoLogging(authCode) {

	return request({
		url: '/qywx/auth/qywx-sso',
		method: 'get',
		params: { auth_code : authCode }
	})
}


// WEBPACK FOOTER //
// ./src/api/qywx.js